<template>
  <div class="c-tabs-content">
    <AutoComplete
      icon="ios-search"
      clearable
      :value="keyword"
      :placeholder="placeholder"
      placement="bottom-start"
      class="c-action-search"
      @on-search="searcHandle"
      @on-change="changeHandle"
    >
      <div class="search-suggest-wrap">
        <ul>
          <li v-for="k in completeData" :key="k.id" @click="queryHandle(k)">
            <span>{{ k.name }}</span>
            <span>覆盖人数：{{ k.num }}</span>
          </li>
        </ul>
      </div>
    </AutoComplete>
    <div class="c-keyword">
      <Spin v-if="loading" size="large" fix />
      <template v-else-if="empty">
        <div class="c-empty">
          <Icon type="ios-filing-outline" size="58" color="#efefef" />
          <span>请在上方输入关键词或点击右侧查关键词</span>
        </div>
      </template>
      <div v-else class="c-list">
        <div class="c-list-head">
          <span>{{ keyword }}</span>
        </div>
        <div class="c-list-body">
          <div class="c-list-item" v-for="word in data" :key="word.id">
            <span class="name">{{ word.name }}</span>
            <span class="num">{{ word.num }}</span>
            <span class="operate">
              <a href="javascript:;" v-if="check(word.id)" class="c-checked-span">已加</a>
              <a v-else href="javascript:;" :class="{ 'c-checked-span': disabled }" @click="selectedHandle(word)">添加</a>
              <a href="javascript:;" @click="queryHandle(word)">查关键词</a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="correlation-word">
      <template v-if="!empty && !disabled">
        <dd>
          <a href="javascript:;" @click="$emit('on-select', data)">添加全部“{{ keyword }}”相关关键词</a>
        </dd>
      </template>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'KeyWord',
  props: {
    value: {
      type: String
    },
    data: {
      type: Array
    },
    completeData: {
      type: Array
    },
    words: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    keyword: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    keyqueried() {
      return this.data.length
    },
    check() {
      return (id) => this.words.map((ret) => ret.id).includes(id)
    },
    empty() {
      return !isArray(this.data) || !this.data.length
    }
  },
  methods: {
    changeHandle(val) {
      if (val === '') this.$emit('on-cancel')
    },
    searcHandle(query) {
      this.$emit('on-complete', query)
    },
    queryHandle(item) {
      this.$emit('on-search', {
        id: item.id,
        name: item.name,
        tag_type: 'KEYWORD'
      })
    },
    selectedHandle(word) {
      if (this.disabled) return
      this.$emit('on-select', [word])
    }
  }
}
</script>
<style lang="scss" scoped>

.c-keyword {
  position: relative;
  height: 308px;
  padding-bottom: 12px;

  .c-list, .c-empty {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .c-list {
    position: relative;

    .c-list-head {
      line-height: 34px;
      height: 34px;
      background-color: #fafbfe;
      color: #333;
      font-size: 14px;
      padding-left: 13px;
    }

    .c-list-body {
     overflow-y: auto;
scrollbar-width: thin;
-webkit-overflow-scrolling: touch;
      height: calc(100% - 34px);
      padding: 8px 12px 0;
    }

    .c-list-item {
      display: flex;
      margin-bottom: 4px;

      span {
      text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
        display: inline-block;
        line-height: 26px;
      }

      .num {
        width: 82px;
      }

      .name {
        width: 220px;
      }

      .operate {
        width: 180px;

        a {
          display: inline-block;

          &:last-child {
            margin-left: 50px;
          }
        }

        .c-checked-span {
          color: #A8D7FF;
          cursor: default;
        }
      }
    }
  }

  .c-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      color: #c1c1c1;
      padding-top: 8px;
    }
  }
}

.correlation-word {
  height: 22px;

  dd {
    margin: 0;
    line-height: 22px;
  }
}

.search-suggest-wrap {
  background-color: #ffffff;

  ul {
    text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
    max-height: 240px;

    li {
      padding: 0 12px 0;
      margin-bottom: 6px;
      display: flex;
      flex-flow: column;

      &:hover {
        background-color: #f3f3f3;
      }

      span:nth-child(1) {
        font-size: 14px;
        line-height: 22px;
      }

      span:nth-child(2) {
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }
    }
  }
}

::v-deep .ivu-select-dropdown-list {
  margin-bottom: 0;
}
</style>
